import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

import { RoesbergModule } from '@ldw/roesberg';

import { SharedModule } from '../shared/shared.module';

import { PdfHistoryViewerComponent } from './pdf-history-viewer/pdf-history-viewer.component';
import { PdfViewerComponent } from './pdf-viewer/pdf-viewer.component';

@NgModule({
  declarations: [PdfHistoryViewerComponent, PdfViewerComponent],
  exports: [PdfHistoryViewerComponent, PdfViewerComponent],
  imports: [CommonModule, NgxExtendedPdfViewerModule, SharedModule, RoesbergModule],
})
export class PdfViewModule {}
